import type { IdentityHealthDetails } from '@/types/api';
import type { Translate } from '@/lib/i18n';
import { formatNumber, formatPct } from '@/lib/format';

export function identityHealthSummary(details: IdentityHealthDetails | undefined, t: Translate) {
  if (!details) return undefined;

  const coverage = t(
    `${details.evaluatedAccountCount}/${details.totalAccountCount} comptes évalués · ${details.evaluatedReelCount} reels mesurés après 72 h`,
    `${details.evaluatedAccountCount}/${details.totalAccountCount} accounts evaluated · ${details.evaluatedReelCount} reels measured after 72 h`,
  );
  const quality =
    details.reelsScore === null
      ? t('Qualité indisponible', 'Quality unavailable')
      : t(
          `Qualité ${formatNumber(details.reelsScore)}/100`,
          `Quality ${formatNumber(details.reelsScore)}/100`,
        );
  const crashes = t(
    `${details.crashedAccountCount} compte(s) en chute confirmée`,
    `${details.crashedAccountCount} account(s) with a confirmed collapse`,
  );
  const period = t(
    `2 périodes complètes de ${details.trendPeriodDays} j (UTC)`,
    `2 complete ${details.trendPeriodDays}-day periods (UTC)`,
  );
  const trend =
    details.viewsGrowthPct === null
      ? t('Tendance indisponible : ajustement neutre', 'Trend unavailable: neutral adjustment')
      : t(
          `Vues ${formatPct(details.viewsGrowthPct / 100)} · ${formatNumber(details.currentPeriodViews)} vs ${formatNumber(details.previousPeriodViews)} · ${details.trendAccountCount} compte(s) comparables`,
          `Views ${formatPct(details.viewsGrowthPct / 100)} · ${formatNumber(details.currentPeriodViews)} vs ${formatNumber(details.previousPeriodViews)} · ${details.trendAccountCount} comparable account(s)`,
        );

  return `${coverage}. ${quality}. ${crashes}. ${trend} · ${period}.`;
}
